import CRUDService from "./geral/CRUDService";

export default class EmpresaService extends CRUDService{
    constructor() {
        super("empresa");
    }
}